<template>
	<div class="parent">
		<dialogue
		:title="'Success'"
		:paragraph="save_dialogue_text"
		:button_names="['Accept','Copy']"
		:show="save_dialogue"
		:autoClose="false"
		v-on:dialogue="saveDialogue"
		v-on:cancel="saveDialogueCancel"
		></dialogue>
		<dialogue
		:title="'Error'"
		:paragraph="error_dialogue_text"
		:button_names="['Accept']"
		:show="error_dialogue"
		v-on:cancel="errorDialogue"
		></dialogue>

		<div>
		<p v-if="term==undefined" style="font-size:45px; margin:10px;">{{title}}</p>
		<p v-else style="font-size:45px; margin:10px;">{{title+': '+term}}</p>
		</div>

		<div class="scroll" v-bind:style="navbar?'margin-bottom:50px':'margin-bottom:10px'">
			<table style="position:relative; z-index:1">
				<tr v-for="(column, index) in add_names">
					<template
					v-if="add_names[index].substr(add_names[index].length-4) == 'Time'">
						<td>
							{{add_names[index]}}
						</td>
						<td>
							<datetime
							v-model="table_data[index]"
							style="width:100%"
							/>
						</td>
					</template>
					<template
					v-else-if="add_names[index].substr(add_names[index].length-5) == 'Times'">
						<template
						v-if="job_type == '5• AAA,6• AAD' || job_type == '9• COM,6• AAD'">
							<td>
								{{add_names[index].slice(0,-1)}}
							</td>
							<td>
								<datetime
								v-model="table_data[index]"
								style="width:100%"
								/>
							</td>
						</template>
						<template v-else>
							<td/>
							<td class="empty"/>
						</template>
					</template>
					<template
					v-else-if="add_names[index] == 'JobType'">
						<td>
							{{add_names[index]}}
						</td>
						<td>
							<jobtype
							:index="index"
							:search="table_data[index]"
							:use_radio=use_radio
							v-on:input="setJobType"
							style="width:100%"
							>
							</jobtype>
						</td>
					</template>
					<template
					v-else-if="add_names[index] == 'RadioStatus'">
						<td>
							Status
						</td>
						<td>
							<status
							:index="index"
                            :status=table_data[index]
							v-on:input="setStatus"
							style="width:100%"
							>
							</status>
						</td>
					</template>
					<template
					v-else-if="add_names[index] == 'Side'">
						<td>
							{{add_names[index]}}
						</td>
						<td>
							<autocomplete
							:list="['Starboard','Port']"
							v-model=table_data[index]
							:type="add_types[index]"
							style="width:100%"
							/>
						</td>
					</template>
					<template
					v-else-if="add_names[index] == '_Status'">
						<td>
							{{add_names[index].substr(1,add_names[index].length-1)}}
						</td>
						<td>
							<autocomplete
							:list="['Open','Completed','Cancelled','Internal']"
							v-model=table_data[index]
							:type="add_types[index]"
							style="width:100%"
							/>
						</td>
					</template>
					<template
					v-else-if="add_names[index] == 'Status'">
						<td>
							{{add_names[index]}}
						</td>
						<td>
							<autocomplete
							:list="['Unassigned','Assigned']"
							v-model=table_data[index]
							:type="add_types[index]"
							style="width:100%"
							/>
						</td>
					</template>
					<template
					v-else-if="add_names[index].substr(0,1) == '_'">
						<td>
							{{add_names[index].substr(1,add_names[index].length-1)}}
						</td>
						<td>
							<input
							style="width:100%"
							v-model="table_data[index]"
							/>
						</td>
					</template>
					<template
					v-else>
						<td>
							{{add_names[index]}}
						</td>
						<td>
							<autocomplete
							v-model=table_data[index]
							:type="add_types[index]"
							style="width:100%"
							>
							</autocomplete>
						</td>
					</template>
				</tr>
			</table>
		</div>

		<div class="nav-bar">
			<div>
				<button :disabled="button_disabled" v-on:click="cancel()">Cancel</button><button :disabled="button_disabled" v-on:click="save()">Save</button>
			</div>
		</div>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
        id: Number,
		navbar:Boolean,
		use_radio:Boolean,
		title:'',
		term: '',
		reroute: {
            type: Boolean,
            required: false,
            default: true
		},
    },
	data() {
		return {
			add_names: [],
			add_types: [],
			table_data:[],
			job_type:'',
            cancelReason:'',
            statusComment:'',

			save_dialogue:false,
			save_dialog_text:'',

			error_dialogue:false,
			error_dialog_text:'',

			button_disabled:false,
		}
	},
	async created () {
		this.getTables()
	},
	methods: {
		setJobType(index, value){
			this.job_type = value;
			this.table_data[index] = value;
		},
		setStatus(index, value, reason, comment){
            this.cancelReason = reason;
            this.statusComment = comment;
			this.table_data[index] = value;
		},
		getTables (){
			api.postData(
				{
					type:"add",
					data:{
						pageid:this.id,
						term:this.term,
					}
				}
			).then((res) => {
				if(res.data.column_data)
					this.table_data = res.data.column_data;
				this.add_names = res.data.column_names;
				this.add_types = res.data.column_types;
			});
        },
        save (){
			this.button_disabled = true;

			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.id,
						data:this.table_data,
                        cancelReason: this.cancelReason,
                        statusComment: this.statusComment,
						term:this.term,
					}
				}
			).then((res) => {
				if(res.data.errors!=undefined) {
					var message = '';
					for(var i = 0;i<res.data.errors.length;i++){
						message+="\n"+res.data.errors[i];
					}
					message = message.slice(1,message.length)

					this.error_dialogue_text = message
					this.error_dialogue = true
			    }else {

					var message = '';
					for(var i = 0;i<res.data.orderids.length;i++){
						message+="\n"+res.data.orderids[i];
					}
					message = message.slice(1,message.length)

					this.save_dialogue_text = message
					this.save_dialogue = true
			    }
			}).catch((err) => {
					this.button_disabled = false;
					this.error_dialogue_text = err.response
						? "Request failed: " + (err.response.data && err.response.data.error ? err.response.data.error : err.response.status)
						: "Request failed: " + err.message;
					this.error_dialogue = true;
			});
        },
		saveDialogueCancel(){
			this.save_dialogue = false
			this.$emit('save');
			//router.push('/'+res.data.to+'?q='+res.data.search);
			if(this.reroute==true){
				router.go(-1)
			}
		},
		saveDialogue(buttonname){
			if(buttonname == 'Copy'){
				this.copyText();
			}else{
				this.saveDialogueCancel()
			}
		},
		errorDialogue(){
			this.error_dialogue = false
			this.button_disabled = false
		},
		cancel (){
			api.postData(
				{
					type:"button",
					data:{
						pageid:this.id,
						data:this.table_data,
						term:this.term,
						buttonname:'Cancel',
					}
				}
			).then((res) => {
				if(res.data.data.to!=null) {
					if(res.data.data.useterm) {
						router.push('/'+res.data.data.to+'?q='+this.term);
					} else {
						router.push('/'+res.data.data.to);
					}
				}
			});
        },
		async copyText(){

			var el = document.createElement('textarea');
		    el.value = this.save_dialogue_text;
		    document.body.appendChild(el);
		    el.select();
			el.setSelectionRange(0, 99999);
		    document.execCommand('copy');
		    document.body.removeChild(el);
		},
	}
}
</script>

<style>
.empty {
	background-color: #e7e7e7;
}
</style>



// WEBPACK FOOTER //
// src/layouts/layout_2.vue